$('.slider').slick({
  // normal options...
    infinite: false,
    dots: true,
    arrows:false,
    slidesToShow: 1,
// responsive: [
//     {
//       breakpoint: 480,
//       settings: {
// slidesToScroll: 2} 
// },
// ]
});


